import { mergePublicLocale } from './merge-locale';

export type Language = 'fr' | 'en' | 'es' | 'it' | 'de' | 'ar' | 'pt' | 'uk' | 'ru' | 'lb' | 'tr';

export const defaultLanguage: Language = 'en';
export const supportedLanguages: Language[] = ['fr', 'en', 'es', 'it', 'de', 'ar', 'pt', 'uk', 'ru', 'lb', 'tr'];

// Landing
import frLandingTranslations from './landing/fr.json';
import enLandingTranslations from './landing/en.json';
import esLandingTranslations from './landing/es.json';
import itLandingTranslations from './landing/it.json';
import deLandingTranslations from './landing/de.json';
import landingPtPatch from './landing/pt.patch.json';
import landingUkPatch from './landing/uk.patch.json';
import landingRuPatch from './landing/ru.patch.json';
import landingLbPatch from './landing/lb.patch.json';

// Pricing
import frPricingTranslations from './pricing/fr.json';
import enPricingTranslations from './pricing/en.json';
import esPricingTranslations from './pricing/es.json';
import itPricingTranslations from './pricing/it.json';
import dePricingTranslations from './pricing/de.json';

// Accessibility
import frAccessibilityTranslations from './accessibility/fr.json';
import enAccessibilityTranslations from './accessibility/en.json';
import esAccessibilityTranslations from './accessibility/es.json';
import itAccessibilityTranslations from './accessibility/it.json';
import deAccessibilityTranslations from './accessibility/de.json';

// About
import frAboutTranslations from './about/fr.json';
import enAboutTranslations from './about/en.json';
import esAboutTranslations from './about/es.json';
import itAboutTranslations from './about/it.json';
import deAboutTranslations from './about/de.json';

// Contact
import frContactTranslations from './contact/fr.json';
import enContactTranslations from './contact/en.json';
import esContactTranslations from './contact/es.json';
import itContactTranslations from './contact/it.json';
import deContactTranslations from './contact/de.json';

// Use Cases
import frUseCasesTranslations from './use-cases/fr.json';
import enUseCasesTranslations from './use-cases/en.json';
import esUseCasesTranslations from './use-cases/es.json';
import itUseCasesTranslations from './use-cases/it.json';
import deUseCasesTranslations from './use-cases/de.json';

// Public Header
import frPublicHeaderTranslations from './public-header/fr.json';
import enPublicHeaderTranslations from './public-header/en.json';
import esPublicHeaderTranslations from './public-header/es.json';
import itPublicHeaderTranslations from './public-header/it.json';
import dePublicHeaderTranslations from './public-header/de.json';
import ptPublicHeaderTranslations from './public-header/pt.json';
import ukPublicHeaderTranslations from './public-header/uk.json';
import ruPublicHeaderTranslations from './public-header/ru.json';
import lbPublicHeaderTranslations from './public-header/lb.json';

// Public Footer
import frPublicFooterTranslations from './public-footer/fr.json';
import enPublicFooterTranslations from './public-footer/en.json';
import esPublicFooterTranslations from './public-footer/es.json';
import itPublicFooterTranslations from './public-footer/it.json';
import dePublicFooterTranslations from './public-footer/de.json';
import ptPublicFooterTranslations from './public-footer/pt.json';
import ukPublicFooterTranslations from './public-footer/uk.json';
import ruPublicFooterTranslations from './public-footer/ru.json';
import lbPublicFooterTranslations from './public-footer/lb.json';

// Login
import frLoginTranslations from './login/fr.json';
import enLoginTranslations from './login/en.json';
import esLoginTranslations from './login/es.json';
import itLoginTranslations from './login/it.json';
import deLoginTranslations from './login/de.json';

import arLandingTranslations from './landing/ar.json';
import arPricingTranslations from './pricing/ar.json';
import arAccessibilityTranslations from './accessibility/ar.json';
import arAboutTranslations from './about/ar.json';
import arContactTranslations from './contact/ar.json';
import arUseCasesTranslations from './use-cases/ar.json';
import arPublicHeaderTranslations from './public-header/ar.json';
import arPublicFooterTranslations from './public-footer/ar.json';
import arLoginTranslations from './login/ar.json';

import frLeBrefTranslations from './le-bref/fr.json';
import enLeBrefTranslations from './le-bref/en.json';
import esLeBrefTranslations from './le-bref/es.json';
import itLeBrefTranslations from './le-bref/it.json';
import deLeBrefTranslations from './le-bref/de.json';
import arLeBrefTranslations from './le-bref/ar.json';
import ptLeBrefTranslations from './le-bref/pt.json';
import ukLeBrefTranslations from './le-bref/uk.json';
import ruLeBrefTranslations from './le-bref/ru.json';
import lbLeBrefTranslations from './le-bref/lb.json';

import frConsentTranslations from './consent/fr.json';
import enConsentTranslations from './consent/en.json';
import esConsentTranslations from './consent/es.json';
import itConsentTranslations from './consent/it.json';
import deConsentTranslations from './consent/de.json';
import arConsentTranslations from './consent/ar.json';
import ptConsentTranslations from './consent/pt.json';
import ukConsentTranslations from './consent/uk.json';
import ruConsentTranslations from './consent/ru.json';
import lbConsentTranslations from './consent/lb.json';

import trLandingTranslations from './landing/tr.json';
import trPricingTranslations from './pricing/tr.json';
import trAccessibilityTranslations from './accessibility/tr.json';
import trAboutTranslations from './about/tr.json';
import trContactTranslations from './contact/tr.json';
import trUseCasesTranslations from './use-cases/tr.json';
import trPublicHeaderTranslations from './public-header/tr.json';
import trPublicFooterTranslations from './public-footer/tr.json';
import trLoginTranslations from './login/tr.json';
import trConsentTranslations from './consent/tr.json';
import trLeBrefTranslations from './le-bref/tr.json';

const ptLandingMerged = mergePublicLocale(enLandingTranslations, landingPtPatch);
const ukLandingMerged = mergePublicLocale(enLandingTranslations, landingUkPatch);
const ruLandingMerged = mergePublicLocale(enLandingTranslations, landingRuPatch);
const lbLandingMerged = mergePublicLocale(enLandingTranslations, landingLbPatch);

export const translations: Record<Language, any> = {
  fr: {
    landing: frLandingTranslations,
    pricing: frPricingTranslations,
    accessibilityPage: frAccessibilityTranslations.accessibilityPage,
    about: frAboutTranslations,
    contact: frContactTranslations,
    useCases: frUseCasesTranslations,
    publicHeader: frPublicHeaderTranslations,
    publicFooter: frPublicFooterTranslations,
    login: frLoginTranslations,
    consent: frConsentTranslations,
    leBref: frLeBrefTranslations,
  },
  en: {
    landing: enLandingTranslations,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: enPublicHeaderTranslations,
    publicFooter: enPublicFooterTranslations,
    login: enLoginTranslations,
    consent: enConsentTranslations,
    leBref: enLeBrefTranslations,
  },
  es: {
    landing: esLandingTranslations,
    pricing: esPricingTranslations,
    accessibilityPage: esAccessibilityTranslations.accessibilityPage,
    about: esAboutTranslations,
    contact: esContactTranslations,
    useCases: esUseCasesTranslations,
    publicHeader: esPublicHeaderTranslations,
    publicFooter: esPublicFooterTranslations,
    login: esLoginTranslations,
    consent: esConsentTranslations,
    leBref: esLeBrefTranslations,
  },
  it: {
    landing: itLandingTranslations,
    pricing: itPricingTranslations,
    accessibilityPage: itAccessibilityTranslations.accessibilityPage,
    about: itAboutTranslations,
    contact: itContactTranslations,
    useCases: itUseCasesTranslations,
    publicHeader: itPublicHeaderTranslations,
    publicFooter: itPublicFooterTranslations,
    login: itLoginTranslations,
    consent: itConsentTranslations,
    leBref: itLeBrefTranslations,
  },
  de: {
    landing: deLandingTranslations,
    pricing: dePricingTranslations,
    accessibilityPage: deAccessibilityTranslations.accessibilityPage,
    about: deAboutTranslations,
    contact: deContactTranslations,
    useCases: deUseCasesTranslations,
    publicHeader: dePublicHeaderTranslations,
    publicFooter: dePublicFooterTranslations,
    login: deLoginTranslations,
    consent: deConsentTranslations,
    leBref: deLeBrefTranslations,
  },
  ar: {
    landing: arLandingTranslations,
    pricing: arPricingTranslations,
    accessibilityPage: arAccessibilityTranslations.accessibilityPage,
    about: arAboutTranslations,
    contact: arContactTranslations,
    useCases: arUseCasesTranslations,
    publicHeader: arPublicHeaderTranslations,
    publicFooter: arPublicFooterTranslations,
    login: arLoginTranslations,
    consent: arConsentTranslations,
    leBref: arLeBrefTranslations,
  },
  /** Pages tarifaires / contact / etc. : repli sur l’anglais tant que des fichiers dédiés ne sont pas ajoutés. La home fusionne le bloc `decision` traduit. */
  pt: {
    landing: ptLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ptPublicHeaderTranslations,
    publicFooter: ptPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ptConsentTranslations,
    leBref: ptLeBrefTranslations,
  },
  uk: {
    landing: ukLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ukPublicHeaderTranslations,
    publicFooter: ukPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ukConsentTranslations,
    leBref: ukLeBrefTranslations,
  },
  ru: {
    landing: ruLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: ruPublicHeaderTranslations,
    publicFooter: ruPublicFooterTranslations,
    login: enLoginTranslations,
    consent: ruConsentTranslations,
    leBref: ruLeBrefTranslations,
  },
  lb: {
    landing: lbLandingMerged,
    pricing: enPricingTranslations,
    accessibilityPage: enAccessibilityTranslations.accessibilityPage,
    about: enAboutTranslations,
    contact: enContactTranslations,
    useCases: enUseCasesTranslations,
    publicHeader: lbPublicHeaderTranslations,
    publicFooter: lbPublicFooterTranslations,
    login: enLoginTranslations,
    consent: lbConsentTranslations,
    leBref: lbLeBrefTranslations,
  },
  tr: {
    landing: trLandingTranslations,
    pricing: trPricingTranslations,
    accessibilityPage: trAccessibilityTranslations.accessibilityPage,
    about: trAboutTranslations,
    contact: trContactTranslations,
    useCases: trUseCasesTranslations,
    publicHeader: trPublicHeaderTranslations,
    publicFooter: trPublicFooterTranslations,
    login: trLoginTranslations,
    consent: trConsentTranslations,
    leBref: trLeBrefTranslations,
  },
};
